export default __webpack_public_path__ + "static/media/torne-edge.a32552ae.svg";